import createReactComponent from '../createReactComponent';
var Ticket = createReactComponent('Ticket', [['path', {
  d: 'M3 9V7a2 2 0 012-2h14a2 2 0 012 2v2M3 15v2a2 2 0 002 2h14a2 2 0 002-2v-2',
  key: '19qxoz'
}], ['path', {
  d: 'M21 15a3 3 0 110-6',
  key: 'u8dcbu'
}], ['path', {
  d: 'M3 15a3 3 0 100-6',
  key: 'km07i3'
}], ['path', {
  d: 'M13 5v2',
  key: 'dyzc3o'
}], ['path', {
  d: 'M13 17v2',
  key: '1ont0d'
}], ['path', {
  d: 'M13 11v2',
  key: '1wjjxi'
}]]);
export default Ticket;